import script from "./GroupItem.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupItem.vue?vue&type=script&setup=true&lang=js"

import "./GroupItem.vue?vue&type=style&index=0&id=f927e686&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f927e686"]])

export default __exports__